import { Sparkles, Gem, Scissors, Brush, Flower2, Wand2, Eye, LucideIcon } from 'lucide-react'

export interface ServiceItem {
  name: string
  desc: string
  price: string
  note?: string
  image?: string
}

export interface ServiceCategory {
  icon: LucideIcon
  name: string
  items: ServiceItem[]
  image?: string
  imageAlt?: string
}

export const SQUARE_BOOKING_URL =
  'https://book.squareup.com/appointments/5r4c1vrtw6oy03/location/LRN8SSDGVPZM9/services'

export const SQUARE_PAYMENT_URL = 'https://square.link/u/LpXv1Mpe'

export const SERVICE_IMAGES = {
  spaBody: 'https://cdn.magicpatterns.com/uploads/3a8mdzoZKJJqoPAaSyYn8w/SPA_SLIMMING_BODY.png',
  maquillaje: 'https://cdn.magicpatterns.com/uploads/rqDj2bcWDT1fLgS5nQJPGq/MAQUILLAJE2.png',
  limpiezaFacial:
    'https://cdn.magicpatterns.com/uploads/4u9dtBRN5cF9z5V2qxXUns/FACIALES_LIMPIEZA_FACIAL.png',
  cejas: 'https://cdn.magicpatterns.com/uploads/d2V7QiKmcWJCJXRiHzT5Ln/CEJAS_PERFECTAS.png',
  pestanas: 'https://cdn.magicpatterns.com/uploads/43VtYRFrAQi4yjKcYPRdFV/LIFTING_DE_PESTANAS.png',
  masajesSpa: 'https://cdn.magicpatterns.com/uploads/tgdGVkHofmHEJsYyNG1LAW/MASAJES_SPA.png',
  botoxCapilar: 'https://cdn.magicpatterns.com/uploads/vdLDP2WBNKixGdwCaLNN3b/BOTOX_CAPILAR.png',
  keraBotox: 'https://cdn.magicpatterns.com/uploads/wX7xqs4BqCwHABfax8uLYQ/KERA_BOTOX.png',
  spaCapilar: 'https://cdn.magicpatterns.com/uploads/2S5kPYj7pwdinEjNTZcJbS/SPA_CAPILAR.png',
  sombreadoCejas:
    'https://cdn.magicpatterns.com/uploads/7GYrXxviZ2YQ2krKjBoTT8/SOMREADO_DE_CEJAS.png',
  kTipExtension:
    'https://cdn.magicpatterns.com/uploads/bLmhgnU69c3AdAUHWiS5TG/K_TIP_EXTENSION.png',
  colorCompleto: 'https://cdn.magicpatterns.com/uploads/xB6v5W3WXBjdgZsP1uVtXb/COLOR_CPMLETO.png',
  sombreadoCejas2:
    'https://cdn.magicpatterns.com/uploads/wiEyBoqXwmGE1GHvPytWgx/SOMBREADO_DE_CEJAS.png',
  highlights: 'https://cdn.magicpatterns.com/uploads/rLSyHuzPCEU13f7Rmof7Ru/HIGHLIGHTS.png',
  keratina: 'https://cdn.magicpatterns.com/uploads/ad1pPVBsQwh51PXnUiwJij/KERATINA_2.png',
  alisadoGinger:
    'https://cdn.magicpatterns.com/uploads/crDKD1h3iiTkBLfAJmTcrw/ALISADO_GINGER.png',
  alisadoJapones:
    'https://cdn.magicpatterns.com/uploads/uzAzAN82odNiFns6PdGRUk/ALISADO_JAPONES.png',
  colorCompleto2: 'https://cdn.magicpatterns.com/uploads/chU41e6qUEH4RzdhPqXQxF/COLOR_CPMLETO.png',
  balayage: 'https://cdn.magicpatterns.com/uploads/mfNGtCg34hyCKBSyzkgvxh/BALAYAGE_GINGER.png',
  retoqueRaiz: 'https://cdn.magicpatterns.com/uploads/crH1xe2Dv7fbkYxPuEjyNS/RETOQUE_DE_RAIZ.png',
  peinado: 'https://cdn.magicpatterns.com/uploads/bw6nFFADJo4tFa4bHD9QnQ/PEINADO_2.png',
  corteDama: 'https://cdn.magicpatterns.com/uploads/2xirDeMzacfvFCzgUXowwL/CORTE_PARA_DAMA.png',
  blowout: 'https://cdn.magicpatterns.com/uploads/i4xgnaBma1jgWFRWwAypUg/BLOWOUT.png',
  maquillajeGlowUp:
    'https://cdn.magicpatterns.com/uploads/2tK8vnrEJNeLxbpa44unTF/MAQUILLAJE_GLOW_UP.png',
  maquillajeFullFace:
    'https://cdn.magicpatterns.com/uploads/jWeQvXY982xsfSGJiLt1B5/MAQUILLAJE_FULL_FACE.png',
  asesoriaImagen:
    'https://cdn.magicpatterns.com/uploads/9SLHTvNMv3NMGfhH8Lky5k/ASESORIA_DE_IAMGEN.png',
  maquillajeSocial:
    'https://cdn.magicpatterns.com/uploads/ra4R43dsn9LYdbJqBgEpMF/MAQUILLAJE_SOCIAL.png',
  repolarizacion:
    'https://cdn.magicpatterns.com/uploads/4tBTijicFHRZ8rcJaL5DtL/REPOLARIZACION_ANTIFRIZZ.png',
  liftingCapilar:
    'https://cdn.magicpatterns.com/uploads/d21DEmtVopSgU4eS5fWG5t/LIFTING_CAPILAR.png',
  cocktailCapilar:
    'https://cdn.magicpatterns.com/uploads/cSwoqPPQZXVY8mZtn4QjfJ/COCKTAIL_CAPILAR.png',
  nanoplastia: 'https://cdn.magicpatterns.com/uploads/oqt2TwbEQ7VSCLyhJizn7b/NANOPLASTIA.png',
  deepConditioning:
    'https://cdn.magicpatterns.com/uploads/2NS1buHF9JEmz3pGzqckLh/DEEP_CONDITIONING_TREATMENT.png',
  cirugiaCapilar:
    'https://cdn.magicpatterns.com/uploads/pqprTLMpv24wPvfrYKcgNw/cirugia_capilar.png',
  keraplastia: 'https://cdn.magicpatterns.com/uploads/hszzTr2SKH7kwAEfQ3wtDj/keraplastia.png',
  tratamientoBambu:
    'https://cdn.magicpatterns.com/uploads/uYnGtHVUc52barvUpqtfSr/Tratamiento_bambu.png',
  moneyPieceFullFace:
    'https://cdn.magicpatterns.com/uploads/wzLYYcdXtG8usBohU3b3sN/MONEY_PIECE_FULL_FACE.png',
  spaAlivioExpress:
    'https://cdn.magicpatterns.com/uploads/aKkiJWziScsz94TW44rMW5/spa_alivio_express.png',
  extensionHandTied:
    'https://cdn.magicpatterns.com/uploads/mWXjq86eXPfgDTFUH55wvj/extension_hand_tied.png',
  extensionIndividual:
    'https://cdn.magicpatterns.com/uploads/9pcQhCqMX93KMxzddZPmLH/extension_individual2.png',
}

export const serviceCategories: ServiceCategory[] = [
  {
    icon: Sparkles,
    name: 'Coloración & Técnicas de Color',
    image: SERVICE_IMAGES.balayage,
    imageAlt: 'Balayage con transición dorada natural y ondas suaves',
    items: [
      {
        name: 'Retoque de Raíz',
        desc: 'Renovación del color desde la raíz para mantener tu tono uniforme y radiante. Incluye consulta de colorimetría personalizada.',
        price: 'Desde $60',
        image: SERVICE_IMAGES.retoqueRaiz,
      },
      {
        name: 'Coloración Completa',
        desc: 'Cambio total de color con tonos a medida para tu piel, estilo de vida y personalidad. Resultado profesional y duradero.',
        price: 'Desde $140',
        image: SERVICE_IMAGES.colorCompleto2,
      },
      {
        name: 'Balayage',
        desc: 'La técnica de iluminación artística a mano que da ese efecto natural de "beso de sol". Suave, elegante y de bajo mantenimiento.',
        price: 'Desde $280',
        image: SERVICE_IMAGES.balayage,
      },
      {
        name: 'Highlights / Mechas',
        desc: 'Iluminaciones estratégicas que aportan dimensión, movimiento y luminosidad al cabello. Perfectas para cualquier tono base.',
        price: 'Desde $280',
        image: SERVICE_IMAGES.highlights,
      },
      {
        name: 'Money Piece Full Face',
        desc: 'Iluminación enmarcando el rostro para aportar luz inmediata a tu mirada. El cambio más rápido y favorecedor sin tocar todo el cabello.',
        price: 'Desde $120',
        image: SERVICE_IMAGES.moneyPieceFullFace,
      },
    ],
  },
  {
    icon: Gem,
    name: 'Tratamientos Capilares Premium',
    image: SERVICE_IMAGES.keratina,
    imageAlt: 'Cabello con acabado liso y brillo espejo tras tratamiento de keratina',
    items: [
      {
        name: 'Keratina',
        desc: 'Alisado progresivo que elimina el frizz, sella la fibra capilar y aporta brillo intenso. Ideal para cabello grueso y rebelde.',
        price: 'Desde $200',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.keratina,
      },
      {
        name: 'Alisado Láser',
        desc: 'Tecnología láser que sella el tratamiento hebra por hebra para un liso espejo, duradero y con máximo brillo.',
        price: 'Desde $400',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.alisadoGinger,
      },
      {
        name: 'Alisado Japonés',
        desc: 'Alisado de alta duración que reestructura el cabello para un resultado completamente liso y sedoso.',
        price: 'Desde $250',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.alisadoJapones,
      },
      {
        name: 'Bótox Capilar',
        desc: 'Reconstrucción profunda que rellena, hidrata y revitaliza cada hebra desde adentro. Sin químicos agresivos.',
        price: 'Desde $180',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.botoxCapilar,
      },
      {
        name: 'Nanoplastia',
        desc: 'La evolución del alisado. Nanopartículas que alisan, nutren y restauran el cabello sin formaldehído.',
        price: 'Desde $80',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.nanoplastia,
      },
      {
        name: 'Kera-Botox',
        desc: 'Lo mejor de dos mundos: el alisado de la keratina con la nutrición reconstructora del bótox capilar.',
        price: 'Desde $180',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.keraBotox,
      },
      {
        name: 'Keraplastia',
        desc: 'Tratamiento de keratina reforzada que reduce el volumen, controla el frizz y deja un acabado pulido.',
        price: 'Desde $150',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.keraplastia,
      },
      {
        name: 'Lifting Capilar',
        desc: 'Reestructuración que devuelve cuerpo, movimiento y elasticidad al cabello debilitado.',
        price: 'Desde $100',
        image: SERVICE_IMAGES.liftingCapilar,
      },
      {
        name: 'Cocktail Capilar',
        desc: 'Mezcla de activos personalizada según el diagnóstico de tu cabello. Hidratación exprés con resultado inmediato.',
        price: 'Desde $50',
        image: SERVICE_IMAGES.cocktailCapilar,
      },
      {
        name: 'Repolarización Antifrizz',
        desc: 'Sella la cutícula y devuelve el equilibrio al cabello poroso. Adiós al frizz, hola brillo.',
        price: 'Desde $80',
        image: SERVICE_IMAGES.repolarizacion,
      },
      {
        name: 'Tratamiento Bambú',
        desc: 'Fortalecimiento natural con extracto de bambú que aporta resistencia, suavidad y luminosidad.',
        price: 'Desde $80',
        image: SERVICE_IMAGES.tratamientoBambu,
      },
      {
        name: 'Cirugía Capilar',
        desc: 'Reparación intensiva para cabello muy dañado por químicos o calor. Reconstruye la fibra desde el interior.',
        price: 'Desde $180',
        note: 'Precio según largo',
        image: SERVICE_IMAGES.cirugiaCapilar,
      },
      {
        name: 'Spa Capilar',
        desc: 'Ritual completo de limpieza profunda, masaje capilar y nutrición. Relajación total para ti y tu cabello.',
        price: 'Desde $100',
        image: SERVICE_IMAGES.spaCapilar,
      },
      {
        name: 'Deep Conditioning Treatment',
        desc: 'Acondicionamiento profundo que restaura la hidratación y deja el cabello suave, manejable y con movimiento.',
        price: 'Desde $40',
        image: SERVICE_IMAGES.deepConditioning,
      },
    ],
  },
  {
    icon: Scissors,
    name: 'Cortes & Styling',
    image: SERVICE_IMAGES.corteDama,
    imageAlt: 'Corte para dama con acabado pulido y brillo natural',
    items: [
      {
        name: 'Corte para Dama',
        desc: 'Corte personalizado según la forma de tu rostro, textura del cabello y estilo de vida. Incluye lavado y secado.',
        price: 'Desde $35',
        image: SERVICE_IMAGES.corteDama,
      },
      {
        name: 'Blowout',
        desc: 'Secado con técnica profesional que deja el cabello liso, con volumen o con las ondas perfectas. Dura hasta 3 días.',
        price: '$45',
        image: SERVICE_IMAGES.blowout,
      },
      {
        name: 'Peinados',
        desc: 'Updos elegantes, ondas hollywoodense, trenzas de alta costura y más. Para bodas, quinceañeras y ocasiones especiales.',
        price: 'Desde $70',
        note: 'Cotización según evento',
        image: SERVICE_IMAGES.peinado,
      },
    ],
  },
  {
    icon: Brush,
    name: 'Maquillaje Profesional',
    image: SERVICE_IMAGES.maquillaje,
    imageAlt: 'Maquillaje profesional aplicado con brocha, acabado natural y luminoso',
    items: [
      {
        name: 'Maquillaje Social',
        desc: 'Look natural y luminoso, perfecto para cenas, reuniones y eventos de día. Larga duración garantizada.',
        price: '$60',
        image: SERVICE_IMAGES.maquillajeSocial,
      },
      {
        name: 'Maquillaje Glow Up',
        desc: 'Acabado radiante con piel luminosa y mirada definida. El punto medio ideal entre natural y glamoroso.',
        price: '$80',
        image: SERVICE_IMAGES.maquillajeGlowUp,
      },
      {
        name: 'Maquillaje Full Face',
        desc: 'Maquillaje completo de alta intensidad con acabado impecable para grandes ocasiones y sesiones de fotos.',
        price: '$100',
        image: SERVICE_IMAGES.maquillajeFullFace,
      },
      {
        name: 'Asesoría de Imagen',
        desc: 'Analizamos tu paleta de colores, tipo de piel y estilo personal para que luzcas increíble todos los días.',
        price: '$60',
        note: 'Sesión 60 min',
        image: SERVICE_IMAGES.asesoriaImagen,
      },
    ],
  },
  {
    icon: Flower2,
    name: 'Masajes & Bienestar',
    image: SERVICE_IMAGES.spaBody,
    imageAlt: 'Masaje corporal con piedras calientes en un ambiente de spa con velas',
    items: [
      {
        name: 'Full Body',
        desc: 'Masaje corporal completo que libera tensión acumulada y devuelve el equilibrio a todo tu cuerpo.',
        price: '$100',
        note: '60 min',
        image: SERVICE_IMAGES.masajesSpa,
      },
      {
        name: 'Spa Alivio Express',
        desc: 'Sesión focalizada en cuello, hombros y espalda. El respiro perfecto cuando tienes poco tiempo.',
        price: '$55',
        note: '30 min',
        image: SERVICE_IMAGES.spaAlivioExpress,
      },
      {
        name: 'Full Experience',
        desc: 'Masaje completo + reflexología + hidratación. El ritual más completo para desconectar por completo.',
        price: '$140',
        note: 'Experiencia completa',
        image: SERVICE_IMAGES.spaBody,
      },
    ],
  },
  {
    icon: Wand2,
    name: 'Extensiones',
    image: SERVICE_IMAGES.kTipExtension,
    imageAlt: 'Resultado de extensiones de cabello largo con ondas iluminadas',
    items: [
      {
        name: 'Hair Extensions K-Tip',
        desc: 'Extensiones de queratina aplicadas hebra por hebra para un resultado natural, ligero y de larga duración.',
        price: '$500 – $3,000',
        note: 'Según cantidad y largo',
        image: SERVICE_IMAGES.kTipExtension,
      },
      {
        name: 'Hair Extensions Hand Tied',
        desc: 'Técnica cosida a mano que aporta volumen y largo con máxima comodidad y un acabado invisible.',
        price: 'Consulta',
        note: 'Cotización personalizada',
        image: SERVICE_IMAGES.extensionHandTied,
      },
      {
        name: 'Hair Extensions Individual',
        desc: 'Colocación individual para densificar zonas específicas o añadir largo de forma discreta.',
        price: 'Consulta',
        note: 'Cotización personalizada',
        image: SERVICE_IMAGES.extensionIndividual,
      },
    ],
  },
  {
    icon: Eye,
    name: 'Facial & Mirada',
    image: SERVICE_IMAGES.limpiezaFacial,
    imageAlt: 'Limpieza facial profesional en cabina de spa',
    items: [
      {
        name: 'Limpieza Facial',
        desc: 'Limpieza profunda que purifica, desincrusta e hidrata la piel dejándola fresca y luminosa.',
        price: 'Desde $80',
        image: SERVICE_IMAGES.limpiezaFacial,
      },
      {
        name: 'Cejas Perfectas',
        desc: 'Diseño de cejas a medida de tu rostro para enmarcar la mirada con una forma equilibrada y natural.',
        price: '$60',
        image: SERVICE_IMAGES.cejas,
      },
      {
        name: 'Sombreado de Cejas',
        desc: 'Relleno y definición con acabado difuminado que aporta densidad y profundidad a tus cejas.',
        price: '$60',
        image: SERVICE_IMAGES.sombreadoCejas2,
      },
      {
        name: 'Lifting de Pestañas',
        desc: 'Curvatura y elevación de tus pestañas naturales para una mirada abierta y despierta por semanas.',
        price: '$60',
        image: SERVICE_IMAGES.pestanas,
      },
    ],
  },
]

export interface Review {
  text: string
  meta: string
  service: string
  amount: string
}

export const reviews: Review[] = [
  {
    text: '"Quería un cambio que se viera elegante, natural y con mucha luz, y superó por completo mis expectativas. El color quedó precioso, con una transición perfecta y un acabado súper profesional. La experiencia completa fue un 10/10. Desde que llegué me hicieron sentir muy cómoda. El ambiente del salón es hermoso, relajante y transmite mucha confianza."',
    meta: 'Mishell L. · Queens, NY',
    service: 'Balayage con ondas suaves',
    amount: '$200+',
  },
  {
    text: '"Hoy visité este salón y quedé encantada con la atención de la dueña Ginger. Me atendió personalmente, se preocupó por mi rubio y mi cabello quedó súper lacio. Ginger lo hizo genial — sin duda volvería por mi retoque de color."',
    meta: 'Claumile Q. · Corona, NY',
    service: 'Alisado · Tinturado',
    amount: '$200+',
  },
  {
    text: '"El servicio y la atención es de primera. Quería un estilo juvenil y quedé muy bien. La estilista Ginger Briones comprendió lo que quería y me dejó muy feliz."',
    meta: 'Jovanny G. · Queens, NY',
    service: 'Shampoo, Acondicionado & Corte',
    amount: '$20–40',
  },
]

export const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Academia', href: '#academia' },
  { label: 'Reseñas', href: '#resenas' },
  { label: 'Contacto', href: '#contacto' },
]

export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/uV1NS9bjWWc4mRwPMPMPo2/LOGO_GINGER.jpg'
export const BANNER_URL = 'https://cdn.magicpatterns.com/uploads/nDPPGGjxzMz4cKwfWuiYid/BANNER_GINGER_1.png'
